import React, { useId } from 'react';

/**
 * The AI assistant's mark: two sparkles filled with the assistant's
 * gradient. Decorative; the label always sits beside it or on its button.
 */
export default function AiMark({ size = 18, className = '' }) {
  const id = useId().replace(/:/g, '');
  return (
    <svg className={`ai-mark ${className}`} width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <defs>
        <linearGradient id={`ai-g-${id}`} x1="2" y1="2" x2="22" y2="22" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="var(--ai-from)" />
          <stop offset="0.55" stopColor="var(--ai-via)" />
          <stop offset="1" stopColor="var(--ai-to)" />
        </linearGradient>
      </defs>
      <path fill={`url(#ai-g-${id})`} d="M10 2.5c.4 3.6 2.4 5.9 6 6.5-3.6.6-5.6 2.9-6 6.5-.4-3.6-2.4-5.9-6-6.5 3.6-.6 5.6-2.9 6-6.5z" />
      <path fill={`url(#ai-g-${id})`} d="M18 13c.25 2.2 1.45 3.55 3.5 3.9-2.05.35-3.25 1.7-3.5 3.9-.25-2.2-1.45-3.55-3.5-3.9 2.05-.35 3.25-1.7 3.5-3.9z" />
    </svg>
  );
}
